module.exports = __webpack_public_path__ + "static/media/LK_Dashboard.5d18b90e.svg";